import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import ActionGroup from '@/diagrams/models/action-group'
import Match from '@/diagrams/models/match'

@Component
export default class EditActionGroup extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({ default: false })
  private archived!: boolean

  private createNode(evt: CreateNodeEvent): ActionGroup {
    const group = new ActionGroup()
    group.projectId = evt.project.id
    return group
  }

  private selectNode(group: ActionGroup, match: Match): ActionGroup {
    group.name = match.name
    if (match.keywords) {
      group.keywords = match.keywords
    }
    return group
  }
}
